export default "__VITE_ASSET__DkKwD4$R__"